export function normalizeTasteTag(value) {
  return String(value || "").trim().toLowerCase();
}
